import * as Sentry from '@sentry/browser';

import { config } from '../../config';

let isSentryInitialized = false;

if (import.meta.env.PROD) {
    const appVersion = APP_VERSION;
    const trunkVer = config.trunkVer;
    const environment = config.serviceEnvironment;
    const dsn = config.sentryToken;

    const release = trunkVer || appVersion;

    if (dsn && !dsn.startsWith('fake')) {
        isSentryInitialized = true;
        Sentry.init({
            dsn,
            environment,
            release,
            ignoreErrors: [
                'TypeError: Failed to fetch',
                'TypeError: Load failed',
                'TypeError: Cancelled',
                'TypeError: cancelled',
                'TypeError: cancelado',
                'TypeError: Abgebrochen',
                'TypeError: Zeitüberschreitung bei der Anforderung.',
                'TypeError: anulowane',
                'TypeError: annullato',
                'TypeError: NetworkError when attempting to fetch resource.',
                'TypeError: visszavonva',
                'TypeError: отменено',
                'TypeError: annulé',
                'TypeError: geannuleerd',
                'Non-Error promise rejection captured',
                'No state in response',
                'Error: Frame window timed out',
                'Error: Network Error',
                // Can happen when the user's system clock is not yet synchronized, e.g. after daylight savings time change
                /Error: iat is in the future: /,
                'TypeError: error loading dynamically imported module',
                'Error: Redirect aborted',
                'NS_ERROR_UNEXPECTED: No error message',
            ],
        });
    }
}

export const reportErrorToSentry =
    import.meta.env.PROD && isSentryInitialized
        ? (...args: Parameters<typeof Sentry.captureException>) => Sentry.captureException(args)
        : () => '';

const digestMessage = async (message: string) => {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const reportRemindMeLaterClickedToSentry =
    import.meta.env.PROD && isSentryInitialized
        ? async (userId: string | undefined) => {
              try {
                  const userIdHashOrUndefined = userId ? await digestMessage(userId) : undefined;
                  Sentry.captureMessage('Remind me later clicked', { user: { id: userIdHashOrUndefined } });
              } catch (error) {
                  console.error('Error reporting to Sentry:', error);
              }
          }
        : async (_userId: string | undefined) => {};
